import React from 'react'
import { useOutletContext } from 'react-router-dom'

import Paper from '@mui/material/Paper'
import DataEditForm from '~/client/components/DataEditForm'

export default function DataPage() {
  const { documentId } = useOutletContext()
  return <Paper sx={{p: 2, my: 2, maxWidth: 'sm', mx: 'auto'}}>
    <DataEditForm {...{documentId}}/>
  </Paper>
}
